import React from "react";
import DatePicker from "react-datepicker";
import { MdDateRange } from "react-icons/md";
import { transform_timezone } from "../Transformation/Transformations";

function LeaderProfileDatePicker({
  startDate,
  setStartDate,
  filterPassedTime,
  filterPastDates,
  user_timezone,
  t
}) {
  return (
    <div className="dat-picker-wrapper flex flex-col sm:flex-row items-center bg-white rounded-md relative pl-8 sm:pl-12 pr-2 py-2 sm:py-0 gap-2 sm:gap-0">
      {" "}
      {/* Added left padding for icon space */}
      <button
        className="icon_wrapper absolute left-2 sm:left-3 flex items-center justify-center" // Adjusted positioning
        onClick={() =>
          document.querySelector(".dat-picker-wrapper input").focus()
        }
      >
        <MdDateRange size={20} className="sm:w-6 sm:h-6" />
      </button>
      <DatePicker
        className="w-full sm:w-[240px] ml-1 flex-shrink-0"
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        showTimeSelect
        filterTime={filterPassedTime}
        filterDate={filterPastDates}
        dateFormat="MMMM d, yyyy h:mm aa"
        timeFormat="HH:mm"
      />
      <div className="sm:ml-2 whitespace-nowrap text-center text-sm sm:text-base" style={{ color: "red" }}>
        {t(transform_timezone(user_timezone))}
      </div>
    </div>
  );
}

export default LeaderProfileDatePicker;
